/**
 *  @class
 *  @function GiftBar
 */

(() => {
  const handleCartItemsChange = (event) => {
    document.querySelector("#PopupModal-FreeGift1[open]")?.hide();
    document.querySelector("#PopupModal-FreeGift2[open]")?.hide();

    const cartItemsHandles = event.detail.cart.items.map((item) => item.handle);
    console.log(cartItemsHandles);
    document
      .querySelectorAll("gift-bar[data-product-handles]")
      .forEach((giftBar) => {
        const giftBarHandles = giftBar.dataset.productHandles.split(",");
        if (
          giftBarHandles.some((handle) => cartItemsHandles.includes(handle))
        ) {
          giftBar.classList.add("gift-bar--items-added");
        } else {
          giftBar.classList.remove("gift-bar--items-added");
        }
      });
  };

  document.addEventListener("line-item:change:end", handleCartItemsChange);
  document.addEventListener("cart:refresh", handleCartItemsChange);
  document.addEventListener("cart:item-added", handleCartItemsChange);
})();

if (!customElements.get("gift-bar")) {
  class GiftBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amount_text = this.querySelector(".free-shipping--text span");
      let total = parseInt(this.dataset.cartTotal, 10);
      let threshold = Math.round(parseInt(this.dataset.threshold, 10));

      let minimum = Math.round(parseInt(this.dataset.minimum, 10)) || 0;

      let percentage = 1;

      this.remainingText = this.querySelector(".free-shipping--text-remaining");
      this.fullText = this.querySelector(".free-shipping--text-full");
      if (total < threshold) {
        console.table({
          total,
          threshold,
          minimum,
        });
        percentage = (total - minimum) / (threshold - minimum);

        if (amount_text) {
          let remaining = threshold - total,
            format =
              window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = "block";
        this.fullText.style.display = "none";
      } else {
        this.remainingText.style.display = "none";
        this.fullText.style.display = "block";
      }

      if (total < minimum) {
        percentage = 0;
        this.querySelector("button").setAttribute("disabled", "disabled");
      } else {
        this.querySelector("button").removeAttribute("disabled", "disabled");
      }

      if (percentage < 1) {
        this.removeProduct();
      }

      percentage == 1
        ? this.classList.add("gift-bar--full")
        : this.classList.remove("gift-bar--full");

      this.style.setProperty("--percentage", percentage);
    }

    async removeProduct() {
      this.cart = await (await fetch(`${theme.routes.cart_url}.js`)).json();

      const itemsToRemove = this.cart.items
        .filter(
          (item) =>
            this.dataset.productHandles.split(",").includes(item.handle) &&
            Object.keys(item.properties).includes("_isGift")
        )
        .map((itm) => itm.key);

      if (itemsToRemove.length == 0) return;

      itemsToRemove.map((key) => {
        const index = document.querySelector(
          `cart-drawer [data-id='${key}'] + a`
        ).dataset.index;
        document.querySelector("cart-drawer").updateQuantity(index, "0");
      });
    }
  }
  customElements.define("gift-bar", GiftBar);
}
